import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8107f99e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA:")
], -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-21 ant-col-xl-21" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_9 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_10 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_11 = {
  key: 3,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_relatorio_painel_vendas = _resolveComponent("selecionar-tipo-relatorio-painel-vendas")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_selecionar_colaborador = _resolveComponent("selecionar-colaborador")!
  const _component_selecionar_cliente = _resolveComponent("selecionar-cliente")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_campos_relatorio_vendas = _resolveComponent("selecionar-campos-relatorio-vendas")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.modalVisivel,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalVisivel) = $event)),
    title: _ctx.modoEdicao ? 'Alterar Layout do Relatório' : 'Novo Layout do Relatório',
    footer: null,
    width: "80%"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_select, {
                value: _ctx.codigoEmpresa,
                options: _ctx.empresasDisponiveis,
                style: {"width":"100%"},
                optionFilterProp: "label",
                disabled: true
              }, null, 8, ["value", "options"])
            ])
          ]),
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_form_item, {
                    label: "Descrição do Relatório",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dadosCadastro.descricao) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.dadosCadastro.descricao]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_form_item, {
                    label: "Filtrar Por",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_relatorio_painel_vendas, {
                        codigosSelecionados: _ctx.dadosCadastro.tiposFiltro,
                        "onUpdate:codigosSelecionados": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dadosCadastro.tiposFiltro) = $event)),
                        disabled: false,
                        "radio-button": false,
                        varios: true
                      }, null, 8, ["codigosSelecionados"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                (Array.isArray(_ctx.dadosCadastro.tiposFiltro) && _ctx.dadosCadastro.tiposFiltro.includes(1))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Operação",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_operacao, {
                            varios: true,
                            codigosSelecionados: _ctx.tipoOperacaoModal,
                            "onUpdate:codigosSelecionados": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tipoOperacaoModal) = $event)),
                            disabled: false,
                            empresas: [_ctx.codigoEmpresa]
                          }, null, 8, ["codigosSelecionados", "empresas"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (Array.isArray(_ctx.dadosCadastro.tiposFiltro) && _ctx.dadosCadastro.tiposFiltro.includes(2))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_a_form_item, {
                        label: "Vendedor",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_colaborador, {
                            varios: true,
                            codigosSelecionados: _ctx.vendedoresModal,
                            "onUpdate:codigosSelecionados": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vendedoresModal) = $event)),
                            disabled: false,
                            empresas: [_ctx.codigoEmpresa]
                          }, null, 8, ["codigosSelecionados", "empresas"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (Array.isArray(_ctx.dadosCadastro.tiposFiltro) && _ctx.dadosCadastro.tiposFiltro.includes(3))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_a_form_item, {
                        label: "Cliente",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_cliente, {
                            varios: true,
                            codigosSelecionados: _ctx.clientesModal,
                            "onUpdate:codigosSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.clientesModal) = $event)),
                            disabled: false,
                            empresas: [_ctx.codigoEmpresa]
                          }, null, 8, ["codigosSelecionados", "empresas"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (Array.isArray(_ctx.dadosCadastro.tiposFiltro) && _ctx.dadosCadastro.tiposFiltro.includes(4))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_a_form_item, {
                        label: "Produto",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_produto, {
                            varios: true,
                            codigosSelecionados: _ctx.produtosModal,
                            "onUpdate:codigosSelecionados": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.produtosModal) = $event)),
                            disabled: false,
                            empresas: [_ctx.codigoEmpresa]
                          }, null, 8, ["codigosSelecionados", "empresas"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_selecionar_campos_relatorio_vendas, {
                    campos: _ctx.dadosRelatorioCampos,
                    "onUpdate:campos": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dadosRelatorioCampos) = $event))
                  }, null, 8, ["campos"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_a_button, {
                    class: "ant-btn ant-btn-primary ss-btn-tela",
                    onClick: _ctx.handleSalvar
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar Filtros")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}